import { ReactComponent as DashboardIcon } from "assets/MenuIcons/dashboard.svg";
import { ReactComponent as ImpersonateIcon } from "assets/MenuIcons/ImpersonateUser.svg";
import { ReactComponent as LibraryIcon } from "assets/searchicon.svg";
import { ReactComponent as UploadFileMenu } from "assets/UploadFileMenu.svg";
import { ReactComponent as MyPlansIcon } from "assets/write.svg";
import { store } from "redux/store";
import { leftNavItems } from "utils/Types";

export const NavbarItems = [
  {
    label: leftNavItems.dashboard,
    link: "/",
    icon: DashboardIcon,
    getPaths: () => {
      return ["", "property", "planProgress", "userview", "userDashboard"];
    },
    shouldDisplay: () => {
      const state: any = store.getState();
      return !state.app.isAdmin;
    }
  },
  {
    label: leftNavItems.myDashboard,
    link: "/",
    icon: DashboardIcon,
    getPaths: () => {
      return ["", "inncodestats", "planstats"];
    },
    shouldDisplay: () => {
      const state: any = store.getState();
      return state.app.isSmeUser;
    }
  },
  {
    label: leftNavItems.impersonateUser,
    link: "/inncodeUsers",
    icon: ImpersonateIcon,
    getPaths: () => {
      return ["inncodeUsers", "userDashboard"];
    },
    shouldDisplay: () => {
      const state: any = store.getState();
      return state.app.isAdmin;
    }
  },
  {
    label: leftNavItems.library,
    link: "/library",
    icon: LibraryIcon,
    getPaths: () => {
      const state: any = store.getState();
      return state.app.isAdmin && !state.app.isSmeUser
        ? ["library", "plandetails", "functionalArea", ""]
        : ["library", "plandetails", "functionalArea"];
    },
    shouldDisplay: () => {
      return true;
    }
  },
  {
    label: leftNavItems.myPlans,
    link: "/myplans",
    icon: MyPlansIcon,
    getPaths: () => {
      return ["myplans", "myplandetails"];
    },
    shouldDisplay: () => {
      return true;
    }
  },
  {
    label: leftNavItems.uploadFile,
    link: "/recommendations",
    icon: UploadFileMenu,
    getPaths: () => {
      return ["recommendations"];
    },
    shouldDisplay: () => {
      const state: any = store.getState();
      return (
        state.Recommendations.Recommendations.hasRecommendationAccess && !state.app.impersonationDetails.isImpersonated
      );
    }
  }
];
